import styled from 'styled-components';

export const MathsWrapper = styled.div`
  margin: 10px;
  display: flex;
`;
